import Layout from '@/layout'
const storeManagementRouter = {
    path: '/StoreManagement',
    component: Layout,
    redirect: '/StoreManagement/StoreList',
    name: 'StoreManagement',
    alwaysShow: true,
    meta: {
        title: '店铺管理',
        icon: 'sales'
        // icon: 'StoreManagement'
    },
    children: [
        {
         path: '/StoreManagement/StoreList',
         name: "StoreList",
         component: () => import("@/views/storeManagement/storeList/index.vue"),
         meta: {
           title: "店铺列表",
         }
       },
     ]
}

export default storeManagementRouter;